import { v1 as uuidv1 } from 'uuid';

import { createConfigParametersRepository } from '../configParametersRepository';

export const PAGE_RENDER_ID = 'pageRenderId';

export const refreshPageRenderId = () => {
  const pageRenderId = uuidv1();
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();

  if (window?.__htmlEvents__) {
    window.__htmlEvents__.pageRenderId = pageRenderId;
  }

  storageClient?.setInStorage('sessionStorage', PAGE_RENDER_ID, pageRenderId);

  return pageRenderId;
};

const getPageRenderIdBySession = () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  return storageClient?.getFromStorage('sessionStorage', PAGE_RENDER_ID, null);
};

export const getPageRenderId = () => {
  return window?.__htmlEvents__?.pageRenderId || getPageRenderIdBySession();
};
